export default "/images/subtract.svg?d0d8d5bcff3ee9d6d91708bd666ac905";